export default __webpack_public_path__ + "static/media/venkuKrepelkan2.3446df75.jpg";